// config actions
export const CONFIGS_INIT = 'CONFIGS_INIT'
export const CONFIGS_DIRECT_RESET = 'CONFIGS_DIRECT_RESET'
export const CONFIGS_ACTION_RESET = 'CONFIGS_ACTION_RESET'
export const CONFIGS_INIT_MOBILE = 'CONFIGS_INIT_MOBILE'
export const CONFIGS_SET_MOBILE = 'CONFIGS_SET_MOBILE'
export const ERROR_OPEN_API_ERRORS = 'ERROR_OPEN_API_ERRORS'

// TOP画面の見積連番一覧POP
export const TOP_MITUMORI_OPEN = 'TOP_MITUMORI_OPEN'
export const TOP_MITUMORI_CLOSE = 'TOP_MITUMORI_CLOSE'

export const CONFIGS_LOAD_COOKIE = 'CONFIGS_LOAD_COOKIE'
export const READ_NOTICE_LIST = 'READ_NOTICE_LIST'
export const READ_ENTRY_NO_LIST = 'READ_ENTRY_NO_LIST'

export const FILE_UPLOAD = 'FILE_UPLOAD'
export const MYAPP_USER_LOGIN = 'MYAPP_USER_LOGIN'
export const MYAPP_IMAGE_UPLOAD = 'MYAPP_IMAGE_UPLOAD'
export const MYAPP_USER_CREATE = 'MYAPP_USER_CREATE'
export const MYAPP_USER_INSERT = 'MYAPP_USER_INSERT'
export const MYAPP_USER_DELETE = 'MYAPP_USER_DELETE'
export const MYAPP_USER_KANRI = 'MYAPP_USER_KANRI'
export const MYAPP_USER_ALBUM = 'MYAPP_USER_ALBUM'
export const MYAPP_ALBUMCREATE = 'MYAPP_ALBUMCREATE'
export const MYAPP_ALBUM_REMOVE = 'MYAPP_ALBUM_REMOVE'
export const MYAPP_ALBUM_DOMAIN = 'MYAPP_ALBUM_DOMAIN'
export const MYAPP_USER_RIYO = 'MYAPP_USER_RIYO'
export const MYAPP_USER_RIYOEFF = 'MYAPP_USER_RIYOEFF'
export const MYAPP_GET_USER_INFO = 'MYAPP_GET_USER_INFO'
export const MYAPP_ALBUM_IMAGES = 'MYAPP_ALBUM_IMAGES'
export const MYAPP_IMAGES_SETSUMEI = 'MYAPP_IMAGES_SETSUMEI'
export const MYAPP_USER_KENGEN = 'MYAPP_USER_KENGEN'
export const MYAPP_GET_USERPLAN_INFO = 'MYAPP_GET_USERPLAN_INFO'

export const MYAPP_USER_ALBUM_CATALOG = 'MYAPP_USER_ALBUM_CATALOG'

export const MYAPP_CONTRACT_LIST = 'MYAPP_CONTRACT_LIST'
export const MYAPP_CONTRACT_GET = 'MYAPP_CONTRACT_GET'
export const MYAPP_CONTRACT_ADD = 'MYAPP_CONTRACT_ADD'
export const MYAPP_CONTRACT_EDIT = 'MYAPP_CONTRACT_EDIT'
export const MYAPP_CONTRACT_REMOVE = 'MYAPP_CONTRACT_REMOVE'
export const MYAPP_CONTRACT_DISABLED = 'MYAPP_CONTRACT_DISABLED'
export const MYAPP_CONTRACT_ENABLED = 'MYAPP_CONTRACT_ENABLED'

export const MYAPP_IMAGES_REMOVE = 'MYAPP_IMAGES_REMOVE'

export const ACTIONS = {
  // config
  CONFIGS_INIT,
  CONFIGS_DIRECT_RESET,
  CONFIGS_ACTION_RESET,
  CONFIGS_INIT_MOBILE,
  CONFIGS_SET_MOBILE,
  CONFIGS_LOAD_COOKIE,
  // TOP
  TOP_MITUMORI_OPEN,
  TOP_MITUMORI_CLOSE,
  FILE_UPLOAD,
  // ERROR
  ERROR_OPEN_API_ERRORS,
  // APP
  MYAPP_USER_LOGIN,
  MYAPP_IMAGE_UPLOAD,
  MYAPP_USER_CREATE,
  MYAPP_USER_INSERT,
  MYAPP_USER_DELETE,
  MYAPP_USER_KANRI,
  MYAPP_USER_ALBUM,
  MYAPP_ALBUMCREATE,
  MYAPP_ALBUM_REMOVE,
  MYAPP_ALBUM_DOMAIN,
  MYAPP_USER_ALBUM_CATALOG,
  MYAPP_USER_RIYO,
  MYAPP_USER_RIYOEFF,
  MYAPP_GET_USER_INFO,
  MYAPP_ALBUM_IMAGES,
  MYAPP_IMAGES_SETSUMEI,
  MYAPP_USER_KENGEN,
  MYAPP_CONTRACT_LIST,
  MYAPP_CONTRACT_GET,
  MYAPP_CONTRACT_ADD,
  MYAPP_CONTRACT_EDIT,
  MYAPP_CONTRACT_REMOVE,
  MYAPP_CONTRACT_DISABLED,
  MYAPP_CONTRACT_ENABLED,
  MYAPP_GET_USERPLAN_INFO,
  MYAPP_IMAGES_REMOVE
}



// WEBPACK FOOTER //
// ./src/store/action-types.js